
import React from 'react'
import { InfoContainer,InfoBg, ImageBg, InfoContent, InfoP, InfoH1,
  InfoBtnWrapper, AnotherInfoContent, Img1, ImgWrap, Img, ContainAll} from './PreFooterElement'
import PreFooterImg from '../../../images/footer.png'
import Apple from "../../../images/appstore.png"
import Google from "../../../images/googleplay.png"
import PhoneImgKo from '../../../images/phoneko.png';
import PhoneImgEn from '../../../images/phoneen.png';
import "../../../App.css"
import { useTranslation } from 'react-i18next'


const PreFooter = () => {
  const {t} = useTranslation()
  return (
		<>
		<InfoContainer>
      <InfoBg>
        <ImageBg src={PreFooterImg} type='images/footer.png' />
      </InfoBg>
      <Img1 src={localStorage.getItem('i18nextLng') ==="en" ? PhoneImgEn : 
        localStorage.getItem('i18nextLng') ==="ko" ? PhoneImgKo : null } alt='' />
      <ImgWrap>
        {/* <Img src={ ImageOne } alt='' /> */}
      </ImgWrap>
      <ContainAll>
        <InfoContent>
          <InfoP> {t("prefoot.p1")} <br/> {t("prefoot.p2")}</InfoP>
          <InfoH1>SHARE PLUG</InfoH1>
        </InfoContent>
        <AnotherInfoContent>
          <InfoBtnWrapper>
          <a href='/logo' className='downbutton'><img src={Apple} alt='' className='downImage'></img></a>
          <a href='/logo' className='downbutton'><img src={Google} alt='' className='downImage'></img></a>
          </InfoBtnWrapper>
        </AnotherInfoContent>
      </ContainAll>
		</InfoContainer>	
		</>
	)
}

export default PreFooter
